module.exports = __webpack_public_path__ + "static/media/photo-3.5e1fa39c.jpg";